<template>
  <div class="sign-container">
    <div class="header">
      <h2>待签收列表</h2>
      <div class="user-info">
        <span>当前用户：{{ userName }}</span>
      </div>
    </div>

    <div class="search-bar">
      <el-input
        v-model="searchKeyword"
        placeholder="搜索流程编号或标题"
        clearable
        class="search-input"
        @keyup.enter.native="handleSearch"
      />
      <el-button type="primary" @click="handleSearch">搜索</el-button>
      <el-button @click="handleReset">重置</el-button>
    </div>

    <div class="toolbar">
      <el-button 
        type="primary" 
        @click="handleBatchSign"
        :disabled="selectedIds.length === 0"
        :loading="signLoading"
      >
        <el-icon name="check" /> 批量签收 ({{ selectedIds.length }})
      </el-button>
      <el-button 
        type="default" 
        @click="refreshList"
        :loading="loading"
      >
        <el-icon name="refresh" /> 刷新
      </el-button>
    </div>

    <el-table
      :data="signList"
      :loading="loading"
      border
      fit
      highlight-current-row
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="40" />
      <el-table-column label="流程编号" prop="lcbh" min-width="145" />
      <el-table-column label="流程标题" prop="title" min-width="170" />
      <el-table-column label="操作" width="120">
        <template slot-scope="scope">
          <el-button
              type="text"
              size="small"
              @click="handleSingleSign(scope.row)"
              :disabled="scope.row.signed || signLoading"
          >
            {{ scope.row.signed ? '已签收' : '签收' }}
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination" v-if="total > 0">
      <el-pagination
        :current-page="pageNum"
        :page-size="pageSize"
        :total="total"
        :pager-count="3"
        layout="total, prev, pager, next, jumper"
        @current-change="handlePageChange"
        @size-change="handleSizeChange"
      />
    </div>
  </div>
</template>

<script>
import { getSignList, batchSign, checkSigned } from '@/api/sign'

export default {
  name: 'SignList',
  data() {
    return {
      signList: [],
      selectedIds: [],
      pageNum: 1,
      pageSize: 10,
      total: 0,
      loading: false,
      signLoading: false,
      userName: '',
      searchKeyword: ''
    }
  },
  mounted() {
    this.loadSignList()
  },
  methods: {
    async loadSignList() {
      this.loading = true
      try {
        const query = {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          keyword: this.searchKeyword || undefined
        }
        const res = await getSignList(query)
        if (res.code === 200) {
          this.signList = res.data.map(item => ({
            ...item,
            signed: false
          }))
          this.userName = (res.user && res.user.name) || (res.user && res.user.userName) || ''
          this.total = res.total || 0
          this.pageNum = res.pageNum || this.pageNum
          this.pageSize = res.pageSize || this.pageSize
          // await this.checkSignStatus()
        }
      } catch (error) {
        this.$message.error('获取签收列表失败')
      } finally {
        this.loading = false
      }
    },

    async checkSignStatus() {
      for (const item of this.signList) {
        try {
          const res = await checkSigned(item.lcbh)
          if (res.code === 200 && res.signed) {
            item.signed = true
          }
        } catch (error) {
          console.warn('检查签收状态失败:', item.lcbh)
        }
      }
    },

    handleSelectionChange(val) {
      this.selectedIds = val
        .filter(item => !item.signed)
        .map(item => item)
    },

    async handleBatchSign() {

      console.log(this.selectedIds)
      if (this.selectedIds.length === 0) {
        this.$message.warning('请选择要签收的流程')
        return
      }

      this.signLoading = true
      try {
        const res = await batchSign(this.selectedIds)
        if (res.code === 200) {
          this.$message.success(`成功签收 ${res.successCount} 条流程`)
          if (res.successCount !== res.totalCount) {
            this.$message.info(`其中 ${res.totalCount - res.successCount} 条已被签收`)
          }
          this.loadSignList()
        } else {
          this.$message.error(res.message)
        }
      } catch (error) {
        this.$message.error('批量签收失败')
      } finally {
        this.signLoading = false
        this.selectedIds = []
      }
    },

    async handleSingleSign(row) {
      console.log(row)
      if (row.signed) return

      this.signLoading = true
      try {
        const res = await batchSign([row])
        if (res.code === 200) {
          if (res.successCount > 0) {
            this.$message.success('签收成功')
            row.signed = true
          } else {
            this.$message.info('该流程已被签收')
          }
        } else {
          this.$message.error(res.message)
        }
      } catch (error) {
        this.$message.error('签收失败')
      } finally {
        this.signLoading = false
      }
    },

    handleSearch() {
      this.pageNum = 1
      this.loadSignList()
    },

    handleReset() {
      this.searchParams = {
        processId: '',
        title: ''
      }
      this.pageNum = 1
      this.loadSignList()
    },

    refreshList() {
      this.pageNum = 1
      this.loadSignList()
    },

    handlePageChange(val) {
      this.pageNum = val
      this.loadSignList()
    },

    handleSizeChange(val) {
      this.pageSize = val
      this.pageNum = 1
      this.loadSignList()
    }
  }
}
</script>

<style scoped>
.sign-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 5px;
  background-color: #f5f7fa;
  min-height: 100vh;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2px;
  padding: 5px 20px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.header h2 {
  margin: 0;
  font-size: 18px;
  color: #303133;
}

.user-info {
  color: #606266;
  font-size: 14px;
}

.search-bar {
  display: flex;
  gap: 12px;
  margin-bottom: 5px;
  padding: 6px 20px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.search-input {
  width: 200px;
}

.toolbar {
  display: flex;
  gap: 12px;
  margin-bottom: 5px;
}

.pagination {
  display: flex;
  justify-content: center;
  margin-top: 10px;
  padding: 16px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.el-table {
  background: white;
  border-radius: 8px;
  overflow: hidden;
}
</style>